import {
  getMenuOptions,
  getViewList,
  getSwitchView,
  setSwitchView,
  createView,
  editView,
  getQuery,
  deleteView,
  setDefaultView,
  setEnableView,
  setSort
} from '@/services/configListView'

export default {
  namespaced: true,
  state: {
    menuOptions: [],
    listLoading: true,
    viewList: [],
    queryData: [],
    isSwitch: false
  },
  mutations: {
    SET_MENU_OPTIONS (state, data = []) {
      state.menuOptions = data
    },
    SET_VIEW_LIST (state, data = []) {
      state.viewList = data
    },
    SET_LIST_LOADING (state, data) {
      state.listLoading = data
    },
    SET_QUERY_DATA (state, data = {}) {
      state.queryData = data
    },
    SET_SWITCH (state, data) {
      state.isSwitch = data
    }
  },
  getters: {},
  actions: {
    async getMenuOptions ({ commit }, params) {
      let chain = await getMenuOptions()
      return chain
        .params(params)
        .config({ tip: false })
        .onSuccess((payload = []) => {
          commit('SET_MENU_OPTIONS', payload)
        })
        .fetch()
    },
    async getViewList ({ commit }, params) {
      commit('SET_LIST_LOADING', true)
      let chain = await getViewList()
      return chain
        .params(params)
        .config({ tip: false })
        .onSuccess((payload = []) => {
          commit('SET_LIST_LOADING', false)
          commit('SET_VIEW_LIST', payload)
        })
        .fetch()
    },
    async getSwitchView ({ commit }, params) {
      let chain = await getSwitchView()
      return chain
        .params(params)
        .config({ tip: false })
        .onSuccess((payload = {}) => {
          const { switch: isSwitch } = payload
          commit('SET_SWITCH', isSwitch === 1)
        })
        .fetch()
    },
    async setSwitchView ({ commit }, params) {
      let chain = await setSwitchView()
      chain.params(params)

      return chain.fetch()
    },
    async createView ({ commit }, params) {
      let chain = await createView()
      chain.params(params).fetch()

      return chain
    },
    async editView ({ commit }, params) {
      let chain = await editView()
      chain.params(params).fetch()

      return chain
    },
    async getQuery ({ commit }, params) {
      commit('SET_QUERY_DATA', [])
      let chain = await getQuery()
      return chain
        .params(params)
        .config({ tip: false })
        .onSuccess((payload = []) => {
          commit('SET_QUERY_DATA', payload)
        })
        .fetch()
    },
    async deleteView ({ commit }, params) {
      let chain = await deleteView()
      chain.params(params).fetch()

      return chain
    },
    async setDefaultView ({ commit }, params) {
      let chain = await setDefaultView()
      chain.params(params).fetch()

      return chain
    },
    async setEnableView ({ commit }, params) {
      let chain = await setEnableView()
      chain.params(params).fetch()

      return chain
    },
    async setSort ({ commit }, params) {
      let chain = await setSort()
      chain.params(params).fetch()

      return chain
    }
  }
}
